import type { ReactNode } from "react"

const LOCALE_MAP: Record<string, string> = {
  fr: "fr-CH",
  de: "de-CH",
  nl: "nl-NL",
  en: "en-GB",
}

/** Returns the date 7 days before today formatted for the given next-intl locale. */
export function getMockupDate(locale: string): string {
  const date = new Date()
  date.setDate(date.getDate() - 7)
  return new Intl.DateTimeFormat(LOCALE_MAP[locale] ?? "en-GB", {
    day: "numeric",
    month: "long",
    year: "numeric",
  }).format(date)
}

/** Decorative mockup date — suppresses hydration mismatch when HTML was cached on another day. */
export function MockupDate({
  locale,
  className,
}: {
  locale: string
  className?: string
}): ReactNode {
  return (
    <span className={className} suppressHydrationWarning>
      {getMockupDate(locale)}
    </span>
  )
}
